export default "__VITE_ASSET__ee0802a1__"